import { CreateCampaignRequest } from '../types/api.types';

export type CampaignCreateField = 'entity_name' | 'company_name' | 'campaign_name' | 'tier';

export type CampaignCreateValidationErrors = Partial<Record<CampaignCreateField, string>>;

const REQUIRED_FIELD_MESSAGES: Record<CampaignCreateField, string> = {
  entity_name: 'Entity name is required.',
  company_name: 'Company name is required.',
  campaign_name: 'Campaign name is required.',
  tier: 'Tier is required.',
};

const trimToValue = (value?: string): string => (typeof value === 'string' ? value.trim() : '');

export const normalizeCreateCampaignRequest = (data: CreateCampaignRequest): CreateCampaignRequest => ({
  ...data,
  entity_name: trimToValue(data.entity_name),
  company_name: trimToValue(data.company_name),
  campaign_name: trimToValue(data.campaign_name),
  tier: trimToValue(data.tier),
  description: trimToValue(data.description) || undefined,
});

export const validateCreateCampaignRequest = (
  data: Partial<CreateCampaignRequest>
): CampaignCreateValidationErrors => {
  const errors: CampaignCreateValidationErrors = {};

  (Object.keys(REQUIRED_FIELD_MESSAGES) as CampaignCreateField[]).forEach((field) => {
    if (!trimToValue(data[field])) {
      errors[field] = REQUIRED_FIELD_MESSAGES[field];
    }
  });

  return errors;
};

export const isCreateCampaignRequestValid = (data: Partial<CreateCampaignRequest>): boolean =>
  Object.keys(validateCreateCampaignRequest(data)).length === 0;

export const mapCampaignValidationErrors = (
  errors?: Record<string, string[]>
): CampaignCreateValidationErrors => {
  const fieldErrors: CampaignCreateValidationErrors = {};

  if (!errors) {
    return fieldErrors;
  }

  (Object.keys(REQUIRED_FIELD_MESSAGES) as CampaignCreateField[]).forEach((field) => {
    const backendErrors = errors[field];

    if (backendErrors?.length) {
      fieldErrors[field] = backendErrors[0];
    }
  });

  return fieldErrors;
};
